import cls from 'classnames';

const underscoresToHighlights = (text = '', highlightClasses = 'font-bold') => {
  if (!text) return null;

  const uMatches = text.match(/_([^_]+)_/gm) || [];
  let newText = text;
  for (const match of uMatches) {
    let replaceText = match.slice(1, -1);
    replaceText = `<span class="${cls(highlightClasses)}">${replaceText}</span>`;
    newText = newText.replace(match, replaceText);
  }

  newText = newText.replaceAll('\\', '<br/>');
  newText = newText.replaceAll(/\s+/g, ' ');

  return newText;
};

export { underscoresToHighlights };

export const replaceTranslationVariables = (text, replaceMap) => {
  if (!text || typeof text !== 'string' || !replaceMap) return text;

  const variables = Object.keys(replaceMap);
  if (!variables.length) return text;

  for (const variable of variables) {
    const value = replaceMap[variable];
    text = text.replace(`:${variable}`, value);
  }

  return text;
};
